import React, { Component, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as _ from 'lodash';
import moment from 'moment';
import { Grid } from 'semantic-ui-react';
import toastr from 'toastr';
import memoize from 'memoize-one';
import ManageTaskForm from './ManageTaskForm/ManageTaskForm';
import ManageMapView from '../../map/ManageMapView';
import RunEngineView from '../../runEngine/RunEngine';
import TaskList from '../TaskList';
import * as allTaskViewActions from './redux/actions';
import { isTaskTypeParent } from './ManageTaskForm/redux/actions';
import * as appActions from '../../../actions/appActions';
import LeftPanelGrid from '../../left-panel/LeftPanelGrid';
import { EditMode, PLanningMode, SUBSCRIPTION_ERROR_MESSAGES, VIEWS } from '../../../HelperMethods/constants';
import TaskHeader from '../TaskHeader';
import SettingsModal from '../modals/SettingsModal';
import AutomateDailyRunModal from '../modals/AutomateDailyRunModal';
import EditRecurrenceTaskConfirmModal from '../modals/EditRecurrenceTaskConfirmModal';
import * as TaskUtilities from '../../../HelperMethods/TaskUtilities';
import * as DateUtilities from '../../../HelperMethods/DateUtils';
import RecurringTaskList from './RecurringTaskList';
import { STATUS_LIST, GLOBAL_APPROVAL_STATUS } from '../../../HelperMethods/enums';
import EngineLogView from './EngineLogView/EngineLogView';
import TaskMapper from '../../../HelperMethods/Mappers';
import ApiService from '../../../service/apiService';
import logUtils from '../../../HelperMethods/LogUtils';
import BulkEditTasks from './BulkEditPopUp';
import BulkEditTaskForm from './ManageTaskForm/BulkEditTaskForm';
import Joyn2Loader from '../../common/Joyn2Loader';
import { ENTITY_ACCESS_TYPE, RESOURCE_TYPE, RESOURCES } from '../../../HelperMethods/role-resource-constants';
import {
  determineIfUserHasAccessToResource,
  getFieldsAndAreasAccessibleToUser,
} from '../../../HelperMethods/UserUtilities';
import { closeView, CONTAINERS, resetView } from '../../common/cardNavigationComponent/cardNavigationRedux';
import AssigneeCard from '../../common/assigneeCard/AssigneeCard';
import { selectStop, loadUsersLocations } from '../../map/redux/actions';
import CardNavigationComponent from '../../common/cardNavigationComponent/CardNavigationComponent';
import { onCommentUpsertedFromSubscription, onCommentDeletedFromSubscription } from '../../../actions/commentActions';
import { isTaskViewLoadingSelector } from './redux/reducer';
import {
  getSelectedAreasForTaskViewPage,
  getSelectedTaskTypeGroupsForTaskViewPage,
} from '../../../reducers/appReducer';
import { isDateInBetweenDateRange, evaluateEngineSettings } from '../../../HelperMethods/UtilityFunctions';
import { setDateRange, setFinalCenterAndZoomInMapView } from '../../../HelperMethods/LocalStorageUtils';
import {
  doesTaskBelongToSelectedArea,
  shouldShowForLoggedInVendor,
  isTaskParent,
  doesTaskBelongToSelectedTaskTypeGroups,
} from '../../../HelperMethods/TaskUtilities';
import { onPageFocussed } from '../../../HelperMethods/DocumentVisibilityChangeListener';
import JoynFSMPopup from '../../common/JoynFSMPopup';
import { loadVendors as loadVendorsAction } from '../../vendorManagement/redux/actions';
import ConfirmTasksModal from '../ConfirmTasksModal';

const SchedulerView = React.lazy(() => import('./schedulerView/SchedulerView'));

class TaskViewPage extends Component {
  constructor(props, context) {
    super(props, context);
    // all the state variables
    this.state = {
      settingsModalOpen: false,
      automateDailyRunModalOpen: false,
      planningMode: {
        enabled: true, // to show Planning Engine Option or not
        modalOpen: false,
        planningStartDate: null,
        planningEndDate: null,
        usePlanningEngineSettings: false,
        useCrowFlyDistances: null,
        crowFlyDistanceFactorPercentage: null,
      },
      editTaskModalOpen: false,
      selectedTasks: [],
      showBulkEditModal: false,
      bulkEditSaved: false,
      popup: {
        show: false,
        title: '',
        message: '',
      },
      myWatchlist: {
        myWatchlistTaskIds: [],
        selected: false,
      },
    };
    this.publishDetails = null;
    this.planningEngineSettings = null;
    // this.evaluateEngineSettings = this.evaluateEngineSettings.bind(this);
    this.taskListRef = React.createRef();
    this.confirmTasksModalRef = React.createRef();
  }

  getCountOfTasks = memoize((tasks) => {
    const totalNoOfTasks = tasks.length;
    let openTasks = 0;
    let resolvedTasks = 0;
    let unAssignedTasks = 0;
    let draftTasks = 0;
    tasks.forEach((task) => {
      if (task.status.toLowerCase() === STATUS_LIST.DRAFT.key) {
        draftTasks += 1;
      }
      if (task.status.toLowerCase() === STATUS_LIST.OPEN.key) {
        openTasks += 1;
      }
      if (task.status.toLowerCase() === STATUS_LIST.RESOLVED.key) {
        resolvedTasks += 1;
      }
      if (_.size(task.assigneeIds) === 0) {
        unAssignedTasks += 1;
      }
    });
    return {
      totalTasks: totalNoOfTasks,
      openTasks,
      unAssignedTasks,
      draftTasks,
      resolvedTasks,
    };
  });

  getSelectedUserObjects = memoize((userIds) => {
    const { users } = this.props;
    const userIdMap = _.keyBy(users, 'id');
    return userIds.map((userId) => userIdMap[userId]).filter((u) => !!u);
  });

  getFlatTasks = memoize((dbTasks, allAreas, vendorsDict, watcherDetailsDict, assetLevelsDict) => {
    return TaskMapper.DbTaskToFlatTask({ tasks: dbTasks, allAreas, vendorsDict, watcherDetailsDict, assetLevelsDict });
  });

  getRowData = memoize(
    ({
      dbTasks,
      selectedUserIds,
      selectedDateRange,
      allAreas,
      vendorsDict,
      watcherDetailsDict = {},
      assetLevelsDict = {},
      myWatchlist = {},
    }) => {
      const { myWatchlistTaskIds = [], selected = true } = myWatchlist;
      const mappedTasks = this.getFlatTasks(dbTasks, allAreas, vendorsDict, watcherDetailsDict, assetLevelsDict);
      let filteredTasks = this.filterTaskUsingUserIDAndDate(mappedTasks, selectedUserIds, selectedDateRange);
      if (selected) {
        filteredTasks = filteredTasks.filter((task) => myWatchlistTaskIds.includes(task.id));
      }
      const TaskswithAttachmentsdetails = filteredTasks.map((e) => {
        let count = 0;

        const tempObj = e;
        if (!_.isEmpty(e.attachments)) {
          count += e.attachments.length;
        }
        if (!_.isEmpty(_.get(e, 'taskType.attachmentIds', []))) {
          count += _.get(e, 'taskType.attachmentIds', []).length;
        }
        if (!_.isEmpty(_.get(e, 'asset.attachments', []))) {
          count += _.get(e, 'asset.attachments', []).length;
        }
        tempObj.attachmentCount = count;
        return tempObj;
      });
      if (selectedUserIds.length === 1) {
        return this.getSequencedTasks(TaskswithAttachmentsdetails, selectedUserIds[0]);
      }
      return TaskswithAttachmentsdetails;
    }
  );

  componentDidMount() {
    const { loggedInUser, selectedField, fieldsForDropdown, isTaskTypeParentAction, taskViewActions, loadVendors } =
      this.props;
    const fieldAndAreaAccess = getFieldsAndAreasAccessibleToUser(loggedInUser);
    isTaskTypeParentAction(false);
    loadVendors();
    if (!_.isEqual(window.location, window.parent.location)) {
      taskViewActions.setiFramePresentState(true);
    }

    const doesSelectedFieldIsAccessibleForTaskView = fieldAndAreaAccess[selectedField.id]?.length > 0;
    if (!doesSelectedFieldIsAccessibleForTaskView) {
      const someFieldAccessibleToTaskView = fieldsForDropdown.find((f) => fieldAndAreaAccess[f.id]?.length > 0);
      if (!someFieldAccessibleToTaskView) {
        toastr.error('No fields compatible to task view found');
        return;
      }
      this.props.appActions.onFieldChange(someFieldAccessibleToTaskView);
    }

    setTimeout(() => {
      this.loadTasksAndUsers();
      this.subscribeTaskSubscription();
      this.subscribeUserSubscription();
      this.subscribeCommentSubscription();
      // added in bulkinitialDownload
      // taskViewActions.loadSavedFiltersOfUser(loggedInUser.id);
    });
    this.handleRemoveEventListener = onPageFocussed(() => {
      [
        [this.taskSubscription, this.subscribeTaskSubscription, 'task'],
        [this.userManagementSubscription, this.subscribeUserSubscription, 'user'],
        [this.onCommentAddedSubscription, this.subscribeAddCommentSubscription, 'onCommentAdd'],
        [this.onCommentUpdatedSubscription, this.subscribeUpdateCommentSubscription, 'onCommentUpdate'],
        [this.onCommentDeletedSubscription, this.subscribeDeleteCommentSubscription, 'onCommentDelete'],
      ].forEach(([sub, subFunc, subText]) => {
        if (sub?.closed) {
          console.debug(`${subText} subscription is closed. Restarting it!!`);
          subFunc();
          if (subText === 'task') {
            this.loadTasks(true);
          }
        }
      });
    });
  }

  componentDidUpdate(prevProps) {
    const { selectedField: prevSelectedField, selectedDateRange: prevSelectedDateRange } = prevProps;
    const { selectedField, selectedDateRange } = this.props;

    if (prevSelectedField.id !== selectedField.id) {
      // field has been changed
      this.onFieldChange();
    }
    if (prevProps.selectedAreas !== this.props.selectedAreas) {
      this.onAreasChange();
    }
    if (!_.isEqual(prevProps.selectedTaskTypeGroups, this.props.selectedTaskTypeGroups)) {
      this.onTaskTypeGroupsChange();
    }
    if (!_.isEqual(prevSelectedDateRange, selectedDateRange)) {
      this.props.appActions.updateInitialUserConfig();
    }
  }

  componentWillUnmount() {
    const { taskViewActions } = this.props;
    this.unsubscribeTaskSubscription();
    this.unsubscribeUserSubscription();
    this.unsubscribeCommentSubscription();
    taskViewActions.setEmptyTasksAndUsers();
    this.props.appActions.updateInitialUserConfig();
    if (this.handleRemoveEventListener) this.handleRemoveEventListener();
    // if (this.taskListRef && this.taskListRef.current) {
    //   this.taskListRef.current.handleClearFilter();
    // }
  }

  closeModal = (key, value, cancel = true) => {
    this.setState({
      [key]: value,
    });
    if (cancel) {
      this.planEngineSettingsChange({ usePlanningEngineSettings: false });
    }
  };

  onPublish = (publishAsPlanned, isDraftState = false) => {
    const { currentView, taskViewActions } = this.props;
    const {
      planningMode: { usePlanningEngineSettings = false },
    } = this.state;
    if (usePlanningEngineSettings) {
      this.saveSettings(false, this.planningEngineSettings);
    }
    const username = this.props.loggedInUser.userName;
    // in publish as draft, conisder only dirty tasks
    // in publish, consider dirty tasks or drafts [even if they are not edited]
    const tasksToConsider = this.props.tasksStateData.filter((t) => t.isDirty || (!isDraftState && t.draftState));

    taskViewActions
      .publishTasks(tasksToConsider, username, publishAsPlanned, this.publishDetails, isDraftState)
      .then(() => {
        taskViewActions.changeTaskEditMode(EditMode.PUBLISHED);
        taskViewActions.changeTaskPlanningMode(PLanningMode.PLANNINGPUBLISHED);
        this.setView(currentView, true);
        this.publishDetails = null;
        toastr.success(
          `${tasksToConsider.length} Task(s) ${isDraftState ? `saved as Draft.` : `published successfully!`}`
        );
        this.planEngineSettingsChange({ usePlanningEngineSettings: false });
      })
      .catch((error) => {
        logUtils.logError(error, 'Tasks Publish failed');
        this.setIsPageLoading(false);
      });
  };

  onDiscardPublish = () => {
    const { taskViewActions } = this.props;
    this.loadTasks();
    this.planEngineSettingsChange({ usePlanningEngineSettings: false });
    taskViewActions.changeTaskEditMode(EditMode.PUBLISHED);
    taskViewActions.changeTaskPlanningMode(PLanningMode.PLANNINGPUBLISHED);
    this.publishDetails = null;
  };

  editTaskRecurrence = (isOccurrence) => {
    const { history } = this.props;
    const occurrence = !!isOccurrence;
    let taskToBeEdited;
    if (occurrence) {
      taskToBeEdited = this.currentEditTask;
    } else {
      taskToBeEdited = { id: this.currentEditTask.sourceRecurringTaskId };
    }
    history.push(`taskViewPage/task/update/${taskToBeEdited.id}`);
    this.setState({
      editTaskModalOpen: false,
    });
  };

  setManageTaskView = (task) => {
    const { history } = this.props;
    if (!task) {
      history.push('/taskViewPage/task/new');
      return;
    }

    if (TaskUtilities.isTaskOccurrenceOfRecurringAndVirtual(task)) {
      this.currentEditTask = task;
      this.setState({
        editTaskModalOpen: true,
      });
    } else {
      history.push(`/taskViewPage/task/update/${task.id}`);
    }
  };

  setView = (viewName, forcedUpdate = false) => {
    const { taskViewActions, viewStack } = this.props;
    taskViewActions.setView(viewName);
    // if (this.taskListRef && this.taskListRef.current) {
    //   this.taskListRef.current.handleClearFilter();
    // }

    if (forcedUpdate) {
      setTimeout(() => {
        this.loadTasks(true);
      }, 8000);
    }
    if (this.isCurrOrPrevViewSchedulerView(viewName, viewStack[0])) {
      setTimeout(() => {
        this.loadTasks();
      });
    }
  };

  isCurrOrPrevViewSchedulerView = (currView, prevView) => {
    return currView !== prevView && (currView === VIEWS.schedulerView || prevView === VIEWS.schedulerView);
  };

  setIsPageLoading = (isPageLoading) => {
    if (isPageLoading) {
      this.props.taskViewActions.setPageLoading();
      return;
    }
    this.props.taskViewActions.setPageLoaded();
  };

  onFieldChange = () => {
    this.unsubscribeTaskSubscription();
    this.subscribeTaskSubscription();
    this.unsubscribeUserSubscription();
    this.subscribeUserSubscription();
    this.unsubscribeCommentSubscription();
    this.subscribeCommentSubscription();
    this.props.taskViewActions.updateSelectedUserIds([]);
    setFinalCenterAndZoomInMapView();
    this.props.loadUsersLocationsForMapView(this.props.selectedField.id);
  };

  onAreasChange = () => {
    const { selectStopInMapView, taskViewActions } = this.props;
    taskViewActions.updateSelectedUserIds([]);
    selectStopInMapView(null);
    setFinalCenterAndZoomInMapView();
    setTimeout(() => {
      this.loadTasksAndUsers();
    });
  };

  onTaskTypeGroupsChange = () => {
    const { selectStopInMapView } = this.props;
    // taskViewActions.updateSelectedUserIds([]);
    selectStopInMapView(null);
    setFinalCenterAndZoomInMapView();
    setTimeout(() => {
      this.loadTasks();
    });
  };

  loadUsers = () => {
    const { taskViewActions, selectedAreas } = this.props;
    taskViewActions.loadUsersForAreas(selectedAreas);
  };

  loadTasksAndUsers = () => {
    const { selectedAreas, taskViewActions } = this.props;
    if (!selectedAreas.length) {
      toastr.error('No Areas available for the selected field');
      taskViewActions.setEmptyTasksAndUsers();
      return;
    }
    this.loadTasks();
    this.loadUsers();
  };

  onUserSelect = (user) => {
    const {
      resetNavigationView,
      closeNavigationView,
      selectedUserIds: selectedUserIdsProp,
      taskViewActions,
    } = this.props;
    const selectedUserIndex = selectedUserIdsProp.indexOf(user.id);
    // eslint-disable-next-line react/no-access-state-in-setstate
    const selectedUserIds = _.clone(selectedUserIdsProp);
    if (selectedUserIndex > -1) {
      selectedUserIds.splice(selectedUserIndex, 1);
    } else {
      selectedUserIds.push(user.id);
    }
    if (selectedUserIds.length === 1) {
      resetNavigationView(CONTAINERS.MAP_VIEW, { component: AssigneeCard, props: { assigneeId: selectedUserIds[0] } });
    } else {
      closeNavigationView(CONTAINERS.MAP_VIEW);
    }
    taskViewActions.updateSelectedUserIds(selectedUserIds);
  };

  onSelectedDateChange = (range) => {
    const [dates] = range;
    const { endDate, startDate } = dates || {};
    const { taskViewActions } = this.props;
    if (endDate && startDate) {
      const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
      const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
      taskViewActions.changeGridDate({ startDate: formattedStartDate, endDate: formattedEndDate });
      setDateRange(formattedStartDate, formattedEndDate);
      setTimeout(this.loadTasks);
    }
  };

  loadTasks = (loadSilently) => {
    const { currentView, schedulerDates, selectedAreas, selectedTaskTypeGroups } = this.props;
    if (!this.props.isTaskLoading) {
      let startDateGreaterThan = null; // task whose startDate whose start date should have value more than this variable
      let startDateLessThan = null; // // task whose startDate whose start date should have value less than this variable
      const { taskViewActions, selectedField } = this.props;

      if (currentView === VIEWS.schedulerView) {
        startDateGreaterThan = schedulerDates.startDate;
        startDateLessThan = schedulerDates.endDate;
      } else {
        startDateGreaterThan = moment(this.props.selectedDateRange.startDate).startOf('day').toDate();
        startDateLessThan = moment(this.props.selectedDateRange.endDate).endOf('day').toDate();
      }
      taskViewActions.loadAllTasks(
        selectedField,
        selectedAreas,
        startDateGreaterThan,
        startDateLessThan,
        loadSilently,
        selectedTaskTypeGroups
      );
    }
  };

  subscribeUserSubscription = () => {
    const { selectedField, taskViewActions } = this.props;
    const subscriptionInput = {
      fieldId: selectedField.id,
    };
    this.userManagementSubscription = ApiService.onUpdateUser(subscriptionInput).subscribe(
      (res) => {
        const { selectedAreas } = this.props;
        const { fieldId, usersInfo } = _.get(res, 'value.data.onBulkUserChange');
        if (fieldId === selectedField.id)
          taskViewActions.loadUsersSubscription({ usersInfo: JSON.parse(usersInfo), selectedAreas, fieldId });
      },
      (error) => {
        console.error(`subscription error:`);
        console.error(error);
      },
      () => {
        console.debug('subscription completed');
      }
    );
  };

  unsubscribeUserSubscription = () => {
    if (this.userManagementSubscription && this.userManagementSubscription.unsubscribe) {
      this.userManagementSubscription.unsubscribe();
    }
  };

  subscribeAddCommentSubscription = () => {
    const {
      selectedField: { id: fieldId },
      tenantId,
      onCommentUpserted,
    } = this.props;
    this.onCommentAddedSubscription = ApiService.onCommentCreated(fieldId, tenantId).subscribe({
      next: ({
        value: {
          data: { onCreateComment: comment },
        },
      }) => {
        onCommentUpserted(comment);
      },
      error: (err) => {
        console.error(err);
      },
    });
  };

  subscribeUpdateCommentSubscription = () => {
    const {
      selectedField: { id: fieldId },
      tenantId,
      onCommentUpserted,
    } = this.props;
    this.onCommentUpdatedSubscription = ApiService.onCommentUpdated(fieldId, tenantId).subscribe({
      next: ({
        value: {
          data: { onUpdateComment: comment },
        },
      }) => {
        onCommentUpserted(comment);
      },
      error: (err) => {
        console.error(err);
      },
    });
  };

  subscribeDeleteCommentSubscription = () => {
    const {
      selectedField: { id: fieldId },
      tenantId,
      onCommentDeleted,
    } = this.props;
    this.onCommentDeletedSubscription = ApiService.onCommentDeleted(fieldId, tenantId).subscribe({
      next: ({
        value: {
          data: { onDeleteComment: comment },
        },
      }) => {
        onCommentDeleted(comment);
      },
      error: (err) => {
        console.error(err);
      },
    });
  };

  subscribeCommentSubscription = () => {
    this.subscribeAddCommentSubscription();
    this.subscribeUpdateCommentSubscription();
    this.subscribeDeleteCommentSubscription();
  };

  unsubscribeCommentSubscription = () => {
    const { onCommentAddedSubscription, onCommentUpdatedSubscription, onCommentDeletedSubscription } = this;
    if (onCommentAddedSubscription && onCommentAddedSubscription.unsubscribe) onCommentAddedSubscription.unsubscribe();
    if (onCommentUpdatedSubscription && onCommentUpdatedSubscription.unsubscribe)
      onCommentUpdatedSubscription.unsubscribe();
    if (onCommentDeletedSubscription && onCommentDeletedSubscription.unsubscribe)
      onCommentDeletedSubscription.unsubscribe();
  };

  unsubscribeTaskSubscription = () => {
    if (this.taskSubscription && this.taskSubscription.unsubscribe) {
      this.taskSubscription.unsubscribe();
    }
  };

  processTasks = (tasks) => {
    try {
      const {
        taskViewActions,
        selectedAreas,
        selectedDateRange: { endDate, startDate },
        loggedInUser,
        tasksStateData,
        schedulerDates: { startDate: schedulerStartDate, endDate: schedulerEndDate },
        currentView,
        selectedTaskTypeGroups,
      } = this.props;
      const tasksToBeInsertedOrUpdated = [];
      const tasksToBeDeleted = [];
      // check for date range
      for (const task of tasks) {
        let startDateToConsider = startDate;
        let endDateToConsider = endDate;
        if (currentView === VIEWS.schedulerView) {
          startDateToConsider = schedulerStartDate;
          endDateToConsider = schedulerEndDate;
        }
        let dateRangeCheck =
          task?.startTime &&
          isDateInBetweenDateRange({
            startDate: startDateToConsider,
            endDate: endDateToConsider,
            date: moment(task?.startTime).format('YYYY-MM-DD'),
          });
        if (isTaskParent(task) && !dateRangeCheck) {
          // if parent task is of past date then check if exists in redux store
          dateRangeCheck = tasksStateData.find((t) => t.id === task.id);
        }

        if (
          !task.isDeleted &&
          shouldShowForLoggedInVendor(task.assigneeIds, loggedInUser, task.draftState) &&
          doesTaskBelongToSelectedArea(task, selectedAreas) &&
          doesTaskBelongToSelectedTaskTypeGroups(task, selectedTaskTypeGroups) &&
          (TaskUtilities.isTaskSeriesOfRecurrence(task) || dateRangeCheck) &&
          (!task.approvalStatus || task.approvalStatus === GLOBAL_APPROVAL_STATUS.APPROVED.key)
        ) {
          tasksToBeInsertedOrUpdated.push(task);
        } else {
          console.log('onTasksDeleted', task);
          tasksToBeDeleted.push(task);
        }
      }
      if (tasksToBeInsertedOrUpdated.length > 0) {
        taskViewActions.onTasksInsertedOrUpdated(tasksToBeInsertedOrUpdated);
      }
      if (tasksToBeDeleted.length > 0) {
        taskViewActions.onTasksDeleted(tasksToBeDeleted);
      }
    } catch (e) {
      logUtils.logError(e);
    }
  };

  subscribeTaskSubscription = () => {
    const { loggedInUser, selectedField } = this.props;
    const subscriptionInput = { fieldId: selectedField.id, vendorId: loggedInUser.vendorId };

    this.taskSubscription = ApiService.onChangeFieldTask(subscriptionInput).subscribe(
      (taskData) => {
        console.debug('subscription got triggered');
        try {
          const { task } = taskData.value.data.onChangeFieldTask;
          clearTimeout(this.callTaskActions);
          if (this.tasksToBePushedToReducer) {
            this.tasksToBePushedToReducer.push(task);
          } else {
            this.tasksToBePushedToReducer = [task];
          }
          this.callTaskActions = setTimeout(() => {
            this.processTasks(this.tasksToBePushedToReducer);
            this.tasksToBePushedToReducer = null;
          }, 5000);
        } catch (e) {
          logUtils.logError(e);
        }
      },
      (error) => {
        console.error(`subscription error:`);
        console.error(error);
        const errorMessage = _.get(error, 'error.errors[0].message');
        if (SUBSCRIPTION_ERROR_MESSAGES[errorMessage]) {
          this.setState({
            popup: {
              show: true,
              title: 'Subscription Error',
              message: `${SUBSCRIPTION_ERROR_MESSAGES[errorMessage]}. \nRoot Cause - ${errorMessage}`,
            },
          });
        }
      },
      () => {
        console.debug('subscription completed');
      }
    );
  };

  runEngine = (settingsModalState) => {
    const { taskViewActions, selectedUserIds } = this.props;
    const runEngineSettingsKey =
      this.props.selectedAreasActual.length === 1 ? this.props.selectedAreasActual[0].id : this.props.selectedField.id;
    if (!this.props.engineSettings || !this.props.engineSettings[runEngineSettingsKey]) {
      toastr.error('Please update engine settings before runnning the routing engine.');
      return;
    }
    if (selectedUserIds.length > 1) {
      toastr.error('Please select single user or deselect all users.');
      return;
    }
    const engineSettingsForCurrentRun = settingsModalState || this.props.engineSettings[runEngineSettingsKey];
    let startTimeDateLte;
    let autoFreezTimeDateLte;

    if (settingsModalState) {
      const { startTimeLte, startDateLte, autoFreezTimeLte } = settingsModalState;
      startTimeDateLte = moment(startDateLte).startOf('day').add(startTimeLte).subtract(1, 'seconds').toISOString();
      if (autoFreezTimeLte) {
        // check if autoFreezTimeLte is valid time
        autoFreezTimeDateLte = moment().startOf('day').add(autoFreezTimeLte).toISOString();
      }
    } else {
      const { startTimeLte = '00:00' } = engineSettingsForCurrentRun;
      startTimeDateLte = moment().endOf('day').add(startTimeLte).toISOString();
    }

    const currentDate = moment().format('YYYY-MM-DD');

    taskViewActions
      .runEngine(
        this.props.selectedField.id,
        this.props.selectedAreas.map((a) => a.id),
        this.props.tenantId,
        currentDate,
        selectedUserIds[0] || '',
        engineSettingsForCurrentRun,
        null,
        null,
        {},
        null,
        null,
        startTimeDateLte,
        autoFreezTimeDateLte
      )
      .then((response) => {
        if (Object.keys(response.sequenced).length) {
          taskViewActions.changeTaskEditMode(EditMode.UNPUBLISHED);
          this.storePublishDetails({ startDate: currentDate, endDate: currentDate });
        }
      })
      .catch((error) => {
        logUtils.logError(error);
      });
  };

  storePublishDetails = (publishDetails) => {
    this.publishDetails = publishDetails;
  };

  showPlanningToasterMessage = (from, to, prependMessage, postpendMessage) => {
    const { taskViewActions } = this.props;
    taskViewActions.changeTaskPlanningMessage(
      `${prependMessage} from ${DateUtilities.getToastrDateText(from)} to ${DateUtilities.getToastrDateText(
        to
      )}. ${postpendMessage}`
    );
  };

  planningEngine = (
    engineSettingsForPlanning,
    currentPlanningDate,
    planningStartDate,
    planningEndDate,
    currentPlanningStartTime,
    currentPlanningEndTime,
    nextPlanningDaysTasks = {},
    userIdForPlanningEngine
  ) => {
    const { taskViewActions, selectedUserIds } = this.props;

    if (_.isNil(userIdForPlanningEngine)) {
      // it happens just for first time when planning engine is being run
      if (selectedUserIds.length > 1) {
        toastr.error('Please select single user or deselect all users.');
        return;
      }
      userIdForPlanningEngine = selectedUserIds[0] || '';
    }

    if (currentPlanningStartTime.isSameOrAfter(planningEndDate)) {
      taskViewActions.changeTaskPlanningMode(PLanningMode.PLANNINGUNPUBLISHED);
      this.showPlanningToasterMessage(planningStartDate, planningEndDate, 'Planning finished', 'Please publish.');
      this.storePublishDetails({
        startDate: planningStartDate.format('YYYY-MM-DD'),
        endDate: planningEndDate.format('YYYY-MM-DD'),
      });
      return;
    }

    if (currentPlanningStartTime.isSame(planningStartDate)) {
      taskViewActions.changeTaskPlanningMode(PLanningMode.PLANNINGINPROGRESS);
      this.showPlanningToasterMessage(currentPlanningStartTime, currentPlanningEndTime, 'Planning in progress', '');
    } else {
      setTimeout(() => {
        // taskViewActions.changeTaskPlanningMode(PLanningMode.PLANNINGINPROGRESS);
        if (this.props.tasksPlanningState === PLanningMode.PLANNINGINPROGRESS) {
          this.showPlanningToasterMessage(currentPlanningStartTime, currentPlanningEndTime, 'Planning in progress', '');
        }
      }, 3000);
    }

    taskViewActions
      .runEngine(
        this.props.selectedField.id,
        this.props.selectedAreas.map((a) => a.id),
        this.props.tenantId,
        currentPlanningDate,
        userIdForPlanningEngine,
        engineSettingsForPlanning,
        planningStartDate.toISOString(),
        planningEndDate.toISOString(),
        nextPlanningDaysTasks,
        currentPlanningStartTime.toISOString(),
        currentPlanningEndTime.toISOString()
      )
      .then((response) => {
        if (response.sequenced && Object.keys(response.sequenced).length) {
          taskViewActions.changeTaskEditMode(EditMode.UNPUBLISHED);
        }
        let nextTasksTobePlanned = [];
        if (response.notSequenced && response.otherTasks) {
          // taskViewActions.changeTaskPlanningMode(PLanningMode.PLANNINGUNPUBLISHED);
          this.showPlanningToasterMessage(
            currentPlanningStartTime,
            currentPlanningEndTime,
            'Planning finished',
            `${Object.keys(response.sequenced).length} tasks got sequenced`
          );

          nextTasksTobePlanned = { ...response.notSequenced, ...response.otherTasks };
        }
        const newPlanningDate = moment(currentPlanningDate).add(1, 'day').format('YYYY-MM-DD');
        const newPlanningStartTime = currentPlanningStartTime.add(24 * 60, 'minutes');
        const newPlanningEndTime = currentPlanningEndTime.add(24 * 60, 'minutes');

        this.planningEngine(
          engineSettingsForPlanning,
          newPlanningDate,
          planningStartDate,
          planningEndDate,
          newPlanningStartTime,
          newPlanningEndTime,
          nextTasksTobePlanned,
          userIdForPlanningEngine
        );
      })
      .catch((error) => {
        logUtils.logError(error);
      });
  };

  runPlanningEngine = (engineSettingsForPlanning, ...props) => {
    this.planEngineSettingsChange({ engineSettingsForPlanning, usePlanningEngineSettings: true });
    this.planningEngine(engineSettingsForPlanning, ...props);
  };

  openEngineSettings = (planningModeModalOpen = false) => {
    this.setState((state) => {
      return {
        settingsModalOpen: !state.settingsModalOpen,
        planningMode: Object.assign(state.planningMode, {
          modalOpen: planningModeModalOpen,
        }),
      };
    });
  };

  openAutomateDailyRunModal = () => {
    this.setState((state) => ({
      automateDailyRunModalOpen: !state.automateDailyRunModalOpen,
    }));
  };

  saveSettings = (runEngine, settingsModalState, shouldModalclose = true) => {
    const engineSettings = _.cloneDeep(this.props.engineSettings) || {};
    const runEngineSettingsKey =
      this.props.selectedAreasActual.length === 1 ? this.props.selectedAreasActual[0].id : this.props.selectedField.id;
    const evaluatedEngineSettings = evaluateEngineSettings(settingsModalState);
    const fieldOrAreaLevelEngineSettings = {
      [runEngineSettingsKey]: evaluatedEngineSettings,
    };
    Object.assign(engineSettings, fieldOrAreaLevelEngineSettings);
    if (runEngine) {
      this.runEngine(evaluatedEngineSettings);
    } else {
      this.props.appActions
        .updateSettings('runEngineSettings', engineSettings)
        .then(() => {
          toastr.success('Settings Saved Succesfully');
        })
        .catch((e) => {
          logUtils.logError(e, 'Failed saving Engine Settings');
        });
    }
    if (runEngine && shouldModalclose) {
      this.setState({
        settingsModalOpen: false,
      });
    }
  };

  saveAutomateDailyRunSettings = (areaNewSettings, id) => {
    const automateDailyRunSettings = _.cloneDeep(this.props.automateDailyRunSettings) || {};
    const areaLevelSettings = {
      [id]: areaNewSettings,
    };
    Object.assign(automateDailyRunSettings, areaLevelSettings);
    this.props.appActions
      .updateSettings('automateDailyRunSettings', automateDailyRunSettings)
      .then(() => {
        toastr.success('Successfully saved Settings.');
      })
      .catch((e) => {
        logUtils.logError(e, 'Failed saving Engine Settings');
      });
  };

  onTaskBulkDelete = async () => {
    const { selectedTasks } = this.state;
    const checkAccess = this.checkAccessForSelectedTasks(selectedTasks, ENTITY_ACCESS_TYPE.DELETE);
    if (!checkAccess) {
      toastr.error('Your user profile does not have the required role to perform this action');
      return;
    }
    if (this.confirmTasksModalRef?.current) {
      this.confirmTasksModalRef?.current?.handleDeleteTasks(selectedTasks);
    }
  };

  onTasksBulkUnassigned = () => {
    const { selectedTasks } = this.state;

    const checkAccess = this.checkAccessForSelectedTasks(selectedTasks, ENTITY_ACCESS_TYPE.UPDATE);
    if (!checkAccess) {
      toastr.error('Your user profile does not have the required role to perform this action');
      return;
    }
    const ifUnassignPossible = this.checkIfUnassignPossible(selectedTasks);
    if (!ifUnassignPossible) {
      toastr.error('Cannot unassign a mandatory assignee task');
      return;
    }

    if (this.confirmTasksModalRef?.current) {
      this.confirmTasksModalRef?.current?.handleUnassignTasks(selectedTasks);
    }
  };

  onTaskSelectionChanged = (tasks) => {
    this.setState({ selectedTasks: tasks });
  };

  onTaskListGridReady = (params) => {
    this.taskListGridApi = params.api;
  };

  applyFilter = (field, value) => {
    if (!field) {
      this.taskListGridApi.setFilterModel({});
      return;
    }
    const filterModel = this.taskListGridApi.getFilterModel();
    if (filterModel && Object.keys(filterModel).length === 1) {
      const filterObj = filterModel[field] || filterModel[`${field}_1`];
      if (filterObj) {
        if (filterObj.type === 'equals' && filterObj.filter === value) {
          this.taskListGridApi.setFilterModel({});
          return;
        }
      }
    }
    this.taskListGridApi.setFilterModel({
      [field]: { type: 'equals', filter: value, filterType: 'text' },
      [`${field}_1`]: { type: 'equals', filter: value, filterType: 'text' },
    });
  };

  filterTaskUsingUserIDAndDate = (tasks, userIdList, selectedDateRange) => {
    const filteredTasks = tasks.filter((task) => this.shouldTaskBeShowInGrid(task, userIdList, selectedDateRange));
    return filteredTasks;
  };

  /**
   * function to determine if task should be shown in the task grid
   * if userIdList array is empty, assume every task has been selected
   * draft task will appear on every date
   * except parent recurring task, all kinds of task would be shown
   * @param task
   * @param userIdList
   * @param selectedDateRange
   * @returns {boolean}
   */
  shouldTaskBeShowInGrid = (task, userIdList, selectedDateRange) => {
    const { startDate, endDate } = selectedDateRange;
    return (
      (userIdList.length === 0 ||
        userIdList.some((userId) => task.assigneeIds.map((a) => a.assigneeId).includes(userId))) &&
      (isDateInBetweenDateRange({ date: task.startTime, startDate, endDate }) ||
        task.status === STATUS_LIST.DRAFT.key) &&
      !TaskUtilities.isTaskSeriesOfRecurrence(task)
    );
  };

  getSequencedTasks = (tasks, selectedUserId) => {
    const tasksWithSequence = tasks.map((task) => {
      const assigneeObj = task.assigneeIds.find((a) => a.assigneeId === selectedUserId);
      return {
        ...task,
        seqNo: assigneeObj.sequence ?? null,
        assignedToUserId: selectedUserId,
        isAcceptedByAssignee: assigneeObj.isAccepted,
      };
    });
    const nonSequencedTasks = tasksWithSequence.filter((task) => _.isNil(task.seqNo));
    const sequencedTasks = tasksWithSequence.filter((task) => !_.isNil(task.seqNo));
    sequencedTasks.sort((task1, task2) => {
      if (task1.seqNo === task2.seqNo) {
        return task1.startTime.localeCompare(task2.startTime);
      }
      return task1.seqNo - task2.seqNo;
    });
    for (let k = 0; k < nonSequencedTasks.length; k += 1) {
      const nonSequencedTask = nonSequencedTasks[k];
      for (let i = sequencedTasks.length - 1; i >= 0; i -= 1) {
        if (_.get(nonSequencedTask, 'asset.id') === _.get(sequencedTasks[i], 'asset.id')) {
          sequencedTasks.splice(i + 1, 0, nonSequencedTask);
          nonSequencedTasks.splice(k, 1);
          k -= 1;
          break;
        }
      }
    }
    const result = [
      ...sequencedTasks,
      ...nonSequencedTasks.sort((t1, t2) => _.get(t1, 'asset.name').localeCompare(_.get(t2, 'asset.name'))),
    ];
    return result;
  };

  isUserActivityGridVisible = () => {
    const { currentView } = this.props;
    return currentView !== VIEWS.schedulerView;
  };

  hideLocationsTab = () => {
    const { currentView } = this.props;
    return currentView !== VIEWS.mapView;
  };

  checkAccessForSelectedTasks = (tasks, entityAccessType) => {
    const { loggedInUser } = this.props;

    return tasks.every((task) => {
      return determineIfUserHasAccessToResource({
        resource: RESOURCES.ENTITY.TASK,
        resourceType: RESOURCE_TYPE.ENTITY,
        user: loggedInUser,
        entityAccessType,
        entity: task,
      });
    });
  };

  checkIfUnassignPossible = (tasks) => {
    return tasks.every((task) => {
      return TaskUtilities.isUnassignAllowed(task);
    });
  };

  handleBulkEdit = async () => {
    const {
      match: { url: baseUrl },
    } = this.props;
    const { currentView } = this.props;
    const { selectedTasks } = this.state;
    try {
      const checkAccess = this.checkAccessForSelectedTasks(selectedTasks, ENTITY_ACCESS_TYPE.UPDATE);
      if (!checkAccess) {
        toastr.error('Your user profile does not have the required role to perform this action');
        return;
      }
      if (currentView === VIEWS.mapView) {
        this.setState((prevState) => ({ showBulkEditModal: !prevState.showBulkEditModal, bulkEditSaved: false }));
      } else {
        await this.props.taskViewActions.bulkEditTask(selectedTasks);

        this.props.history.push(`${baseUrl}/bulkEditTask`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  handleClearSelectedTasks = () => {
    this.setState({ selectedTasks: [] }, () => {
      this.taskListGridApi.deselectAll();
    });
  };

  handleSaveBulkEdit = async (updatedTasks) => {
    const {
      loggedInUser: { userName },
      taskViewActions,
      tasksEditMode,
    } = this.props;
    try {
      await taskViewActions.editBulkTasks(updatedTasks, userName, tasksEditMode);
      this.taskListGridApi.deselectAll();
      this.setState({ bulkEditSaved: true });
    } catch (e) {
      console.error(e);
    }
  };

  clearSelectedUser = () => {
    const { selectedUserIds, taskViewActions } = this.props;
    if (selectedUserIds.length) {
      taskViewActions.updateSelectedUserIds([]);
    }
  };

  handleMyWathlistTaskIds = (selected, taskIds) => {
    this.setState({
      myWatchlist: { myWatchlistTaskIds: taskIds, selected },
    });
  };

  planEngineSettingsChange({ engineSettingsForPlanning = {}, usePlanningEngineSettings }) {
    if (usePlanningEngineSettings) {
      this.planningEngineSettings = _.cloneDeep(engineSettingsForPlanning);
    } else {
      this.planningEngineSettings = null;
    }
    this.setState((prevState) => {
      return {
        ...prevState,
        planningMode: {
          ...prevState.planningMode,
          usePlanningEngineSettings,
          useCrowFlyDistances: engineSettingsForPlanning.useCrowFlyDistances,
          crowFlyDistanceFactorPercentage: engineSettingsForPlanning.crowFlyDistanceFactorPercentage,
        },
      };
    });
  }

  render() {
    const {
      isTaskLoading,
      isPageLoading,
      tasksStateData,
      selectedDateRange,
      currentView,
      tasksEditMode,
      tasksPlanningState,
      match: { url: baseUrl },
      allAreas = [],
      selectedUserIds,
      schedulerPageLoading,
      iframepresentState,
      selectedTaskTypeGroups = [],
      taskTypes = [],
      vendorsDict = {},
      watcherDetailsDict = {},
      assetLevelsDict = {},
      selectedAreas = [],
    } = this.props;
    const {
      bulkEditSaved,
      showBulkEditModal,
      selectedTasks = [],
      myWatchlist,
      planningMode: { useCrowFlyDistances, crowFlyDistanceFactorPercentage, usePlanningEngineSettings },
    } = this.state;
    const headerHeight = '48pt';
    const selectedUsers = this.getSelectedUserObjects(selectedUserIds);
    let kpi = null;
    let taskListGridRowData = null;
    if (currentView === VIEWS.taskGridView) {
      taskListGridRowData = this.getRowData({
        dbTasks: tasksStateData,
        selectedUserIds,
        selectedDateRange,
        allAreas,
        vendorsDict,
        watcherDetailsDict,
        assetLevelsDict,
        myWatchlist,
      });
      kpi = this.getCountOfTasks(taskListGridRowData);
    }
    const userActivityGridWidth = this.isUserActivityGridVisible() ? 3 : 0;
    return (
      <Grid
        style={{
          margin: '0px',
          padding: '0px',
          height: !iframepresentState ? 'calc(100% - 100px)' : 'calc( 100% - 80px )',
        }}
      >
        {(isTaskLoading || isPageLoading || schedulerPageLoading) && <Joyn2Loader />}
        <Switch>
          <Route path={`${baseUrl}/task/new`} component={ManageTaskForm} />
          <Route
            path={`${baseUrl}/task/bulknew`}
            render={(props) => <ManageTaskForm bulkCreateTasksView {...props} />}
          />
          <Route path={`${baseUrl}/task/update/:taskId`} component={ManageTaskForm} />
          <Route path={`${baseUrl}/engineLogView`} component={EngineLogView} />
          <Route path={`${baseUrl}/runEngineView`} component={RunEngineView} />
          <Route
            path={`${baseUrl}/bulkEditTask`}
            render={(props) => <BulkEditTaskForm {...props} handleClearSelectedTasks={this.handleClearSelectedTasks} />}
          />
        </Switch>
        <Grid.Row style={{ margin: '0px', padding: '0px', height: '100%' }}>
          {this.isUserActivityGridVisible() && (
            <Grid.Column
              width={userActivityGridWidth}
              style={{
                backgroundColor: 'white',
                zIndex: 2,
                height: '100%',
                padding: '0px',
                margin: '0px',
              }}
            >
              <LeftPanelGrid
                selectedUserIds={selectedUserIds}
                onUserSelect={this.onUserSelect}
                clearSelectedUser={this.clearSelectedUser}
                hideLocationsTab={this.hideLocationsTab()}
                selectedTaskTypeGroups={selectedTaskTypeGroups}
                taskTypes={taskTypes}
              />
            </Grid.Column>
          )}

          <Grid.Column
            width={16 - userActivityGridWidth}
            style={{
              padding: '0px',
              margin: '0px',
              overflowY: 'auto',
              overflowX: 'hidden',
              height: '100%',
              display: currentView !== VIEWS.manageTaskForm && currentView !== VIEWS.runEngineView ? 'block' : 'none',
            }}
          >
            {determineIfUserHasAccessToResource({
              resourceType: RESOURCE_TYPE.FEATURE,
              resource: RESOURCES.FEATURE.TASK_LIST_VIEW,
              user: this.props.loggedInUser,
            }) && (
              <>
                <div>
                  <TaskHeader
                    currentView={currentView}
                    tasksEditMode={tasksEditMode}
                    tasksPlanningState={tasksPlanningState}
                    onPublish={this.onPublish}
                    onDiscardPublish={this.onDiscardPublish}
                    onTaskBulkDelete={this.onTaskBulkDelete}
                    runEngine={this.runEngine}
                    planningModeEnabled={this.state.planningMode.enabled}
                    openEngineSettings={this.openEngineSettings}
                    openAutomateDailyRunModal={this.openAutomateDailyRunModal}
                    setView={this.setView}
                    selectedDateRange={this.props.selectedDateRange}
                    onSelectedDateChange={this.onSelectedDateChange}
                    selectedUsers={selectedUsers}
                    headerHeight={headerHeight}
                    kpi={kpi}
                    areTasksSelected={
                      (currentView === VIEWS.taskGridView || currentView === VIEWS.recurringTaskGridView) &&
                      this.state?.selectedTasks?.length > 0
                    }
                    onTaskBulkUnassigned={this.onTasksBulkUnassigned}
                    applyFilter={this.applyFilter}
                    taskListGridApi={this.taskListGridApi}
                    handleBulkEdit={this.handleBulkEdit}
                    selectedTaskLength={this.state?.selectedTasks?.length}
                  />
                </div>
                <div
                  className="tasks-page-container"
                  style={{
                    height: `calc( 100% - ${headerHeight} )`,
                    display: currentView === VIEWS.taskGridView ? 'block' : 'none',
                  }}
                >
                  <TaskList
                    selectedUserIds={selectedUserIds}
                    rowData={taskListGridRowData}
                    tasksEditMode={tasksEditMode}
                    setManageTaskView={this.setManageTaskView}
                    onRowSelectionChanged={this.onTaskSelectionChanged}
                    onGridReady={this.onTaskListGridReady}
                    currentView={currentView}
                    ref={this.taskListRef}
                    selectedTasks={selectedTasks}
                    selectedAreas={selectedAreas}
                    myWatchlist={myWatchlist}
                    handleMyWathlistTaskIds={this.handleMyWathlistTaskIds}
                    setIsPageLoading={this.setIsPageLoading}
                  />
                  <CardNavigationComponent container={CONTAINERS.GRID_VIEW} />
                </div>

                {currentView === VIEWS.recurringTaskGridView && (
                  <div
                    style={{
                      height: `calc( 100% - ${headerHeight} )`,
                    }}
                  >
                    <RecurringTaskList
                      selectedUserIds={selectedUserIds}
                      onTaskEdit={this.setManageTaskView}
                      selectedTasks={selectedTasks}
                      onRowSelectionChanged={this.onTaskSelectionChanged}
                    />
                  </div>
                )}
                {currentView === VIEWS.schedulerView && (
                  <Suspense>
                    <SchedulerView
                      onPublish={this.onPublish}
                      onDiscardPublish={this.onDiscardPublish}
                      planningEngineSettings={{
                        useCrowFlyDistances,
                        crowFlyDistanceFactorPercentage,
                        usePlanningEngineSettings,
                      }}
                    />
                  </Suspense>
                )}
                {currentView === VIEWS.mapView && (
                  <div style={{ height: `calc( 100% - ${headerHeight} )` }} className="map-container">
                    <ManageMapView
                      selectedField={this.props.selectedField}
                      selectedUserIds={selectedUserIds}
                      users={this.props.users}
                      selectedDateRange={this.props.selectedDateRange}
                      clearSelectedUser={this.clearSelectedUser}
                      handleTaskSelection={this.onTaskSelectionChanged}
                      handleBulkEdit={this.handleBulkEdit}
                      bulkEditSaved={bulkEditSaved}
                    />
                  </div>
                )}
              </>
            )}
          </Grid.Column>
          {this.state.settingsModalOpen && (
            <SettingsModal
              size="small"
              open={this.state.settingsModalOpen}
              toggleModalStateKey="settingsModalOpen"
              close={this.closeModal}
              planningModeModalOpen={this.state.planningMode.enabled && this.state.planningMode.modalOpen}
              saveSettings={this.saveSettings}
              planningEngine={this.runPlanningEngine}
              evaluateEngineSettings={evaluateEngineSettings}
              onDiscardPublish={this.onDiscardPublish}
              runEngine={this.runEngine}
            />
          )}
          {this.state.automateDailyRunModalOpen && (
            <AutomateDailyRunModal
              size="large"
              toggleModalStateKey="automateDailyRunModalOpen"
              open={this.state.automateDailyRunModalOpen}
              close={this.closeModal}
              saveAutomateDailyRunSettings={this.saveAutomateDailyRunSettings}
              evaluateEngineSettings={evaluateEngineSettings}
            />
          )}
          {this.state.editTaskModalOpen && (
            <EditRecurrenceTaskConfirmModal
              size="tiny"
              toggleModalStateKey="editTaskModalOpen"
              open={this.state.editTaskModalOpen}
              close={this.closeModal}
              editTaskRecurrence={this.editTaskRecurrence}
            />
          )}
          <ConfirmTasksModal
            ref={this.confirmTasksModalRef}
            taskGridApi={this.taskListGridApi}
            handleClearSelectedTasks={this.handleClearSelectedTasks}
          />
        </Grid.Row>

        {showBulkEditModal && (
          <>
            <BulkEditTasks
              open={showBulkEditModal}
              closeModal={this.handleBulkEdit}
              selectedTasks={this.state.selectedTasks}
              handleSaveBulkEdit={this.handleSaveBulkEdit}
              tasks={tasksStateData}
              currView={currentView}
            />
          </>
        )}
        <JoynFSMPopup
          title={this.state.popup.title}
          message={this.state.popup.message}
          show={this.state.popup.show}
          onClose={() => {
            this.setState((state) => ({ popup: { ...state.popup, show: false } }));
          }}
        />
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  const {
    vendorReducer: { vendors },
    taskViewPageReducer: { watcherDetailsDict = {}, assetLevelsDict = {} },
  } = state;
  return {
    selectedField: state.appReducer.selectedField,
    selectedAreas: getSelectedAreasForTaskViewPage(state),
    selectedTaskTypeGroups: getSelectedTaskTypeGroupsForTaskViewPage(state),
    users: state.taskViewPageReducer.users.items,
    tenantId: state.appReducer.tenantId,
    allTasks: state.taskViewPageReducer.tasks.items,
    loggedInUser: state.appReducer.loggedInUser,
    engineSettings: state.appReducer.settings ? state.appReducer.settings.runEngineSettings : null,
    automateDailyRunSettings: state.appReducer.settings ? state.appReducer.settings.automateDailyRunSettings : {},
    tasksStateData: state.taskViewPageReducer.tasks.items,
    isTaskLoading: state.taskViewPageReducer.tasks.isLoading,
    isPageLoading: isTaskViewLoadingSelector(state),
    selectedDateRange: state.taskViewPageReducer.selectedDateRange,
    currentView: state.taskViewPageReducer.currentView,
    viewStack: state.taskViewPageReducer.viewStack,
    schedulerDates: state.taskViewPageReducer.scheduler,
    tasksEditMode: state.taskViewPageReducer.tasksEditMode,
    tasksPlanningState: state.taskViewPageReducer.tasksPlanningState,
    fieldsForDropdown: state.appReducer.fieldsForDropdown,
    allAreas: state.appReducer.allAreas,
    selectedAreasActual: state.appReducer.selectedAreas,
    selectedUserIds: state.taskViewPageReducer.selectedUserIds,
    schedulerPageLoading: state.taskViewPageReducer.schedulerPageLoading,
    iframepresentState: state.taskViewPageReducer.iframepresentState,
    taskTypes: state.taskTypeReducer.taskTypes,
    vendorsDict: _.keyBy(vendors, 'id'),
    watcherDetailsDict,
    assetLevelsDict,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appActions: bindActionCreators(appActions, dispatch),
    taskViewActions: bindActionCreators(allTaskViewActions, dispatch),
    resetNavigationView: bindActionCreators(resetView, dispatch),
    closeNavigationView: bindActionCreators(closeView, dispatch),
    selectStopInMapView: bindActionCreators(selectStop, dispatch),
    onCommentDeleted: bindActionCreators(onCommentDeletedFromSubscription, dispatch),
    onCommentUpserted: bindActionCreators(onCommentUpsertedFromSubscription, dispatch),
    isTaskTypeParentAction: bindActionCreators(isTaskTypeParent, dispatch),
    loadVendors: bindActionCreators(loadVendorsAction, dispatch),
    loadUsersLocationsForMapView: bindActionCreators(loadUsersLocations, dispatch),
  };
}

TaskViewPage.propTypes = {
  users: PropTypes.array,
  selectedField: PropTypes.object.isRequired,
  taskViewActions: PropTypes.object.isRequired,
  loggedInUser: PropTypes.object,
  resetNavigationView: PropTypes.func.isRequired,
  closeNavigationView: PropTypes.func.isRequired,
  selectStopInMapView: PropTypes.func.isRequired,
  onCommentDeleted: PropTypes.func.isRequired,
  onCommentUpserted: PropTypes.func.isRequired,
  tasksStateData: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired })).isRequired,
  currentView: PropTypes.string.isRequired,
  selectedAreas: PropTypes.arrayOf(PropTypes.object),
  selectedTaskTypeGroups: PropTypes.arrayOf(PropTypes.object),
  selectedAreasActual: PropTypes.arrayOf(PropTypes.object),
  fieldsForDropdown: PropTypes.arrayOf(PropTypes.object),
  viewStack: PropTypes.arrayOf(PropTypes.string).isRequired,
  allTasks: PropTypes.array,
  iframepresentState: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  tasksEditMode: PropTypes.string.isRequired,
  schedulerDates: PropTypes.exact({
    startDate: PropTypes.any,
    endDate: PropTypes.any,
  }),
  isTaskLoading: PropTypes.bool.isRequired,
  selectedDateRange: PropTypes.exact({
    startDate: PropTypes.any,
    endDate: PropTypes.any,
  }),
  tenantId: PropTypes.string.isRequired,
  engineSettings: PropTypes.object,
  appActions: PropTypes.shape({
    updateSettings: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    updateInitialUserConfig: PropTypes.func,
  }),
  isTaskTypeParentAction: PropTypes.any,
  automateDailyRunSettings: PropTypes.object,
  isPageLoading: PropTypes.bool,
  tasksPlanningState: PropTypes.string.isRequired,
  match: PropTypes.object.isRequired,
  allAreas: PropTypes.array,
  selectedUserIds: PropTypes.array,
  schedulerPageLoading: PropTypes.bool,
  taskTypes: PropTypes.arrayOf(PropTypes.object),
  loadVendors: PropTypes.func,
  vendorsDict: PropTypes.object.isRequired,
  watcherDetailsDict: PropTypes.object.isRequired,
  assetLevelsDict: PropTypes.object.isRequired,
  loadUsersLocationsForMapView: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskViewPage);
